import { ISignInRequest } from '../authentication/authentication.types'
import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import {
  ICookiePolicyResponse,
  IFAQResponse,
  IServiceTermsResponse,
  ITutorial,
} from './settings.types'

export class Settings extends ServiceBase {
  public async getTutorial(tag: string): Promise<ITutorial> {
    const url = `/settings/tutorial/${tag}`

    const response = await this.request.get<ITutorial, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getFAQ(): Promise<IFAQResponse> {
    const url = `/settings/faq`

    const response = await this.request.get<IFAQResponse, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getServiceTerms(
    data: ISignInRequest,
  ): Promise<IServiceTermsResponse> {
    const url = `/settings/service-terms`

    const response = await this.request.post<IServiceTermsResponse, IError>(
      url,
      data,
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getServiceTermsByCompany(
    companyId: string,
    data: ISignInRequest,
  ): Promise<IServiceTermsResponse> {
    const url = `/settings/service-terms/${companyId}`

    const response = await this.request.post<IServiceTermsResponse, IError>(
      url,
      data,
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getCookiePolicy(): Promise<ICookiePolicyResponse> {
    const url = `/settings/cookie-policy`

    const response = await this.request.get<ICookiePolicyResponse, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
